import script from "./OnlineView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineView.vue?vue&type=script&setup=true&lang=js"

import "./OnlineView.vue?vue&type=style&index=0&id=f8277ad8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8277ad8"]])

export default __exports__